<template>
  <div>
    <charts-app
      :fetch="fetch"
      :defaultData="defaultData"
      :replaceFormItem="replaceFormItem"
    ></charts-app>
  </div>
</template>

<script>
import aiFriendManageApi from "../../../api/aiFriendManage";
import { modelOptions } from "../../config";
import ChartsApp from "./app.vue";

export default {
  components: { ChartsApp },
  name: "AiFriendModelChart",
  computed: {
    fetch() {
      return aiFriendManageApi.getModelRealtimeImage;
    },
    replaceFormItem() {
      return {
        type: "select",
        label: "模型",
        key: "modelName",
        contentWidth: "200px",
        options: modelOptions,
      };
    },
    defaultData() {
      return {
        appId: null,
        modelName: modelOptions[0].value,
      };
    },
  },
};
</script>

<style lang="scss" scoped></style>
